(() => {
  const prepareImages = (root) => {
    root.querySelectorAll('.themar-home__image-swap').forEach((link) => {
      const template = link.querySelector('.themar-home__hover-template');
      if (!template || link.dataset.themarHoverBound) return;
      link.dataset.themarHoverBound = 'true';
      const loadImage = () => {
        if (link.dataset.themarHoverLoaded) return;
        const image = template.content.querySelector('img')?.cloneNode(true);
        if (!image) return;
        link.dataset.themarHoverLoaded = 'true';
        const enableSwap = () => {
          if (image.naturalWidth > 0) {
            link.classList.add('themar-home__image-swap--ready');
          }
        };
        image.addEventListener('load', enableSwap, { once: true });
        image.addEventListener('error', () => {
          link.classList.remove('themar-home__image-swap--ready');
        }, { once: true });
        template.replaceWith(image);
        if (image.complete) enableSwap();
      };
      link.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'touch' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          loadImage();
        }
      });
      link.addEventListener('focus', loadImage);
    });
  };
  prepareImages(document);
  document.addEventListener('shopify:section:load', (event) => {
    prepareImages(event.target);
  });
})();

